// CONSTANTS are all caps.
const NS = 'TimelineCarousel';
const CLS = 'timelineCarousel';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/timelineCarousel.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import slick from 'slick-carousel';

export class TimelineCarousel {
	constructor($el) {
		// $el is the widget node return by the loadTimelineCarousel function
		this.$el = $el;
	}

	init() {
		this.setTimelineCarousel();
	}

	setTimelineCarousel() {
		// Add Some logic here
		const $wg = $(this.$el);
		const This = this;
		let images = $wg.find(WG + 'slide-image');

		// no images are loaded.
		let imagesLoaded = 0;
		// total number of images in the slider
		let totalImages = images.length;

		images.each(function() {
			let imgSrc = $(this).attr('src');
			let objImg = new Image();
			objImg.src = imgSrc;
			objImg.onload = function() {
				imagesLoaded++;
				if (imagesLoaded == totalImages) {
					This.initSlider();
				}
			};
		});
	}

	initSlider() {
		const $wg = $(this.$el);
		let slider = $wg.find(WG + 'slider');
		let images = $wg.find(WG + 'slide-image');

		images.each(function() {
			let $img = $(this);
			$img.closest(WG + 'slide-wrapper').css({
				'width': $img[0].naturalWidth + 'px',
			});
		});

		let options = {
			centerMode: true,
			slidesToShow: 1,
			arrows: false,
			focusOnSelect: true,
			variableWidth: true,
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						dots: true,
						centerMode: false,
						variableWidth: false,
					},
				},
			],
		};

		slider.slick(options);

		// On before slide change
		slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
			$wg.find(WG + 'timeline-point').removeClass('active');
			$wg.find(WG + 'timeline-point').eq(nextSlide).addClass('active');
		});

		// on timeline clicks
		$wg.on('click', WG + 'timeline-point', function() {
			$wg.find(WG + 'timeline-point').removeClass('active');
			$(this).addClass('active');
			slider.slick('slickGoTo', $(this).index());
		});
	}

	// Add more functions like on above here
}
